// 参加人数の上限（spec.md「非機能要件」）。無料アカウントの数字は環境変数で変えられる（サーバー側で上書き）。
/** 決済サービス（PAY.JP）で支払える最低の金額（円）。有料パックの値段・乗り換え価格・期間限定価格もこれ以上にする */
export const PAYMENT_MIN_JPY = 50;

/** 大会の人数の上限の初期値（2026-10-09。スタジオのシステム設定で変えられる）。チーム戦はチームの数と、全チーム合わせた人数。チームごとの人数は自由（1人と11人でもよい） */
export const TOURNAMENT_LIMITS_DEFAULT = { maxPlayers: 8, maxTeams: 4, maxTeamPlayers: 12 } as const;

export const LIMITS = {
  individualMaxPlayers: 50,
  teamMaxTeams: 8,
  teamMaxDevicesPerTeam: 10,
  nicknameMaxLength: 10,
  freeMaxPlayers: 5,
  freeMaxTeams: 2,
} as const;

/** チームの色（最大8チーム）：赤・青・黄・緑・紫・ピンク・橙・茶 */
export const TEAM_COLORS = ['red', 'blue', 'yellow', 'green', 'purple', 'pink', 'orange', 'brown'] as const;
/** 以前の大会の記録には淡色（red-soft など）が残っている */
export type TeamColor = (typeof TEAM_COLORS)[number] | `${'red' | 'blue' | 'yellow' | 'green'}-soft`;
/** チーム名の既定値（色名はカタカナ） */
export const TEAM_NAMES = ['レッドチーム', 'ブルーチーム', 'イエローチーム', 'グリーンチーム', 'パープルチーム', 'ピンクチーム', 'オレンジチーム', 'ブラウンチーム'] as const;

export function teamColorFor(position: number): TeamColor {
  return TEAM_COLORS[position % TEAM_COLORS.length]!;
}

export function teamNameFor(position: number): string {
  return TEAM_NAMES[position % TEAM_NAMES.length]!;
}
